import './App.css';
import {Container, Grid} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {Profile} from "./components/Profile/Profile";
import {Resume} from "./pages/Resume/Resume";
import {Header} from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import {Portfolio} from "./pages/Portfolio/Portfolio";
import {useEffect} from "react";
import emailjs from "@emailjs/browser";
import {registerView} from "./utils/clientId";

function App() {
    useEffect(() => {
        const myFun = async () => {
            try {
                const payload = registerView();
                // fetch("https://personal-email-service-c6fafed671c9.herokuapp.com/resume-view", {
                //     method: 'POST', headers: {
                //         'Content-Type': 'application/json'
                //     }, body: JSON.stringify()
                // });
                fetch("https://personal-email-service-c6fafed671c9.herokuapp.com/resume-view", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
            } catch (e) {
                console.error(e);
            }
        };
        myFun();

    }, []);
    return (
        <Container className={"top_60"} maxWidth={'xl'}>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={4} lg={3}>
                    <Profile/>
                </Grid>
                <Grid item xs>
                    <Header/>
                    <div className="main-content container_shadow">
                        <Routes>
                            <Route path="/react-portfolio/portfolio" element={<Portfolio/>}>
                            </Route>
                            <Route path="/react-portfolio/" element={<Resume/>}>
                            </Route>
                            <Route path="*" element={<Resume/>}>
                            </Route>
                        </Routes>
                    </div>
                    <div className="top_50">
                        <Footer/>
                    </div>
                </Grid>
            </Grid>
        </Container>
    );
}

export default App;
